<script setup>
import { ref, computed , inject} from 'vue'
import { useEntityRoute } from '@/composables/route/useListViewRoute'
const { passwordExpired , removePasswordPrompt} = useEntityRoute()
import { useLoaderStore } from "@/store/loader"

const updatePassword = inject("updatePassword")
defineOptions({
  inheritAttrs: false
})
const loader = useLoaderStore()
const props = defineProps({
  modelValue: String,
  label: String
})

const emit = defineEmits(['update:modelValue'])

const password = ref('')
const confirmPassword = ref('')
const error = ref('')

const isValid = computed(
  () => password.value && password.value === confirmPassword.value
)

async function submit() {
  if (!isValid.value) {
    error.value = 'Passwords do not match.'
    return
  }

  error.value = ''
  // emit('update:modelValue', password.value)
  updatePassword(password.value)
  password.value = ''
  confirmPassword.value = ''
  removePasswordPrompt()
}
</script>

<template>
   <v-alert
    v-if="passwordExpired === 'true'"
    type="warning"
    variant="tonal"
    border="start"
    prominent
    class="mb-4"
  >
  <div class="font-weight-bold mb-1">
      Password Update Required
    </div>

    Your password has expired. You must change your password
    before continuing.
  </v-alert>
  <div class="d-flex flex-column ga-3">
  
<v-text-field
      v-model="password"
      :label="label || 'New Password'"
      type="password"
      density="compact"
      variant="outlined"
      autocomplete="new-password"
      hide-details="auto"
    />

    <v-text-field
      v-model="confirmPassword"
      label="Confirm Password"
      type="password"
      density="compact"
      autocomplete="new-password"
      variant="outlined"
      :error="!!error"
      :error-messages="error"
      hide-details="auto"
    />

    <v-btn
      color="primary"
      size="small"
      @click="submit"
      aria-label="change password"
    >
      Change Password
    </v-btn>
  </div>
</template>

<style scoped>
.password-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.error {
  color: crimson;
  font-size: 0.85rem;
}
</style>